// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1951":"f427140c","2768":"0464188e","3124":"82bf364b","3244":"daeaabb7","3936":"e1e36bfc"}[chunkId] + ".chunk.css";
};